export default __webpack_public_path__ + "static/media/fireplace.a755a431.jpeg";